export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-white mt-12" data-testid="app-footer">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-zinc-500">
          © {new Date().getFullYear()} BreakItDown · Built for focused minds.
        </p>
        <a
          href="https://charlottebryan.com.au/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs uppercase tracking-[0.15em] text-zinc-500 hover:text-[#002FA7] transition-colors"
          data-testid="charlotte-bryan-link-footer"
        >
          A <span className="font-semibold text-zinc-900">Charlotte Bryan</span> app ↗
        </a>
      </div>
    </footer>
  );
}
